import * as React from "react";

import { useAppProvider } from "./AppProvider";

function InnerLink(props, ref) {
  const Component = useAppProvider()?.Link?.component;
  return <Component ref={ref} {...props} />;
}

function InnerUnstyledLink(props, ref) {
  const Component = useAppProvider()?.Link?.unstyled;
  return <Component ref={ref} {...props} />;
}

const Link = React.forwardRef(InnerLink);

const UnstyledLink = React.forwardRef(InnerUnstyledLink);

export { Link, UnstyledLink };
